import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import styles from './LoginSignupModalTitle.module.scss';
import HistoricalMetrics from './LoginSignupModalHistoricalMetrics';

const LoginSignupModalTitle = ({
  renderTitle,
  renderSubtitle,
  isHistoricMetricsExp
}) => (
  <Fragment>
    <p className={styles['login-signup-modal-title__title']}>{renderTitle()}</p>
    <p className={styles['login-signup-modal-title__subtitle']}>
      {!isHistoricMetricsExp && renderSubtitle()}
      <div
        className={styles['login-signup-modal-title__historic-metrics-wrapper']}
      >
        {isHistoricMetricsExp && <HistoricalMetrics />}
      </div>
    </p>
  </Fragment>
);

LoginSignupModalTitle.propTypes = {
  renderTitle: PropTypes.func.isRequired,
  renderSubtitle: PropTypes.func.isRequired,
  isHistoricMetricsExp: PropTypes.bool.isRequired
};

export default LoginSignupModalTitle;
